class SimpleModalOpener extends HTMLElement {
  constructor() {
    super();

    this.modal = null;
    this.modalContent = null;
    this.onKeyUpWindowListener = null;
  }

  connectedCallback() {
    this.onKeyUpWindowListener = (event) => event.code === 'Escape' && this.closeModal()
    window.addEventListener('keyup', this.onKeyUpWindowListener);

    [`click`, `keypress`].forEach((eventName) => {
      this.addEventListener(eventName, (event) => {
        event.preventDefault();

        const title = this.dataset.title ?? ``;
        const description = this.dataset.description ?? ``;

        this.openModal(title, description);
      });
    });
  }

  disconnectedCallback() {
    window.removeEventListener('keyup', this.onKeyUpWindowListener);
  }

  getCloseIconSvg() {
    return `<svg
                aria-label="close modal"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <use xlink:href="#svg-close-icon"></use>
              </svg>`;
  }

  closeModal() {
    if (!this.modalContent || !this.modal) return;

    this.modalContent.style.opacity = "0";

    setTimeout(() => {
      this.modal.remove();
    }, 200);
  }

  openModal(title, description) {
    this.modal = document.createElement('div');
    this.modal.classList.add('simple-modal');
    this.modal.style.zIndex = `99999`;

    this.modalContent = document.createElement('div');
    this.modalContent.classList.add('simple-modal__content');
    this.modalContent.innerHTML = `<button class="close">${this.getCloseIconSvg()}</button><h3>${title}</h3><p>${description}</p>`;

    this.modalContent.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });

    [
      this.modal,
      this.modalContent.querySelector('.close'),
    ].forEach((target) => {
      target.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.closeModal();
      });
    });

    this.modal.append(this.modalContent);
    document.body.prepend(this.modal);
    this.modalContent.querySelector('.close').focus();

    setTimeout(() => {
      this.modalContent.style.opacity = "1";
    }, 1);
  };
}

customElements.define('simple-modal-opener', SimpleModalOpener);
